export enum PreAuthRoutes {
    Login = '/login',
    Welcome = '/welcome',
    RequestPasswordReset = '/request-password-reset',
    RequestPasswordResetCode = '/reset-password',
    Revalidate = '/revalidate/:token',
    // AcceptInvite = '/invite',

    Register = '/register',
    RegisterToken = '/register?token=:token',

    Verify = '/verify',

    CompleteRegistration = '/complete-registration',
}

export enum InviteRoutes {
    LoginToken = '/login?token=:token',

    RegisterToken = '/register?token=:token',

    Invite = '/invite',
    InviteToken = '/invite?token=:token',
}

export const PostAuthRoutes = {
    Dashboard: {
        Dashboard: '/dashboard',
    },
    Users: {
        MyProfile: '/my-profile',
        UserManagement: '/user-management',
        UserManagementUserEdit: '/user-management/user-edit/:id',
    },
    Campaigns: {
        CampaignOverview: '/campaigns/:id',
        CampaignReporting: '/campaigns/:id/reporting',
        CampaignConversionMeasurementTest1234: '/campaigns/:id/conversionmeasurementtest1234',
        CampaignDisplays: '/campaigns/:id/displays',
        CampaignCreatives: '/campaigns/:id/creatives',
        CampaignPopImages: '/campaigns/:id/popImages',
        CampaignCostsPage: '/campaigns/:id/costs',
        CampaignSchedule: '/campaigns/:id/schedule',
        CampaignList: '/campaigns',
        NewCampaignPage: '/campaigns/new',
        UpdateCampaignLineItems: '/campaigns/:id/edit-displays',
        CloneCampaign: '/campaigns/:id/clone',
        DataStatus: '/data-status',
        AcceptCampaignInvite: '/invite',
    },
    Agency: {
        AgencyList: '/agencies',
        AgencyOverview: '/agencies/:id',
    },
    Buyer: {
        BuyerList: '/buyers',
        BuyerOverview: '/buyers/:id',
    },
    Client: {
        ClientList: '/brands',
    },
    Creatives: {
        CreativesSearch: '/creatives',
    },
    Owner: {
        OwnerList: '/owners',
        OwnerOverview: '/owners/:id',
    },
    Admin: {
        AdminHome: '/admin',
        // Top-level rather than under /admin: the API redirects a browser here mid-OAuth flow,
        // and the path is baked into config('oauth.consent_url') on that side.
        AuthorizeMcp: '/authorize-mcp',
        SkinList: '/admin/skins',
        EditSkin: '/admin/skins/:id',
        RoleList: '/admin/roles',
        EditRole: '/admin/roles/:id',
        UserList: '/admin/users',
        EditUser: '/admin/users/:id',
        ImpersonateUser: '/admin/impersonate',
        NewUser: '/admin/users/new',
        MarketList: '/admin/markets',
        FrameSearch: '/admin/frame-search',
        DashboardSetup: '/admin/dashboard-setup',
        EditDashboardConfig: '/admin/dashboard-setup/:id',
        SummarySetup: '/admin/summary-setup',
        EditSummaryConfig: '/admin/summary-setup/:id',
        TaskQueue: '/admin/task_queue',
        NotificationsList: '/admin/notifications',
        NotificationDetail: '/admin/notifications/:id',
        UsageOverview: '/admin/usage',
        UsageFeatures: '/admin/usage/features',
        UsageOrganisation: '/admin/usage/organisations/:type/:id',
        UsageUser: '/admin/usage/users/:id',
    },
    PopDisplays: {
        PopDisplaysHome: '/admin/pop-displays',
        LogFileImportList: '/admin/pop-displays/logfiles',
        LogImportSource: '/admin/pop-displays/log-import-sources',
        ChannelFrameList: '/admin/pop-displays/channel-frames',
        ChannelFrameOverview: '/admin/pop-displays/channel-frames/:id',
        PlayoutExport: '/admin/pop-displays/playoutexport',
        VirtualCampaignBuilder: '/admin/pop-displays/virtualcampaign',
        ScheduleTemplates: '/admin/pop-displays/schedule-templates',
    },
    Displays: {
        DisplaysList: '/admin/displays/displays',
        DisplaysAdminHome: '/admin/displays',
        OwnerList: '/admin/displays/owners',
        PackList: '/admin/displays/packs',
        AnaloguesList: '/admin/displays/analogues',
        DisplaysDisplayEdit: '/admin/displays/display/:id',
        TagsList: '/admin/displays/tags',
        DisplaysTagEdit: '/admin/displays/tag/:id',
        DisplaysOwnerEdit: '/admin/displays/owners/:id',
        CountryList: '/admin/displays/countries',
        DisplaysPackEdit: '/admin/displays/packs/:id',
        DisplaysCountryEdit: '/admin/displays/countries/:id',
        DisplaysMarketEdit: '/admin/displays/markets/:id',
        DisplaysAnalogueScreenEdit: '/admin/displays/analoguescreen/:id',
    },
    Main: {
        MainDashboard: '/dashboard',
    },
    admin: {
        DataStatusLineItems: '/admin/datastatuslineitems',
    },
};
